<template>
  <div
    class="study-reports-aside sprtsnasd std_cont_tabs"
    data-tst="reports_aside"
  >
    <TabBox
      v-if="!mobile"
      class="sprtsnasd_tabbox"
      swKey="sw_tabs_reports_tabletile"
      style="--tbbox-overflow-y: hidden"
      tstPrefix="study"
    >
      <template #default="{ tab }">
        <div class="std_cont">
          <StudyTableTile
            v-if="tab === 'poker_table_tile'"
            :hSpot="hSpot"
            :gameformat="gameformat"
            :street="street"
            :mobile="mobile"
            :hasPlayers="true"
            :hasEmptyFlopBoard
          >
          </StudyTableTile>
          <div
            v-if="tab === 'poker_table'"
            class="d-flex flex-1 gw_table-box-layout"
            style="gap: 1rem; padding: 0.25rem"
          >
            <PokerTableStudy
              :spot="hSpot"
              :hasEmptyFlopBoard
              :namespace
              :gameformat="gameformat"
              class="flex-1 gw_table-box-layout_pokertable"
              style="
                min-width: 22rem;
                font-size: 0.75rem;
                min-height: 14rem;
                --margin-horizontal: 0;
                --cards-space: 0;
                padding: 2rem;
                --clr-table-back: var(--clr-black-0-3);
              "
            />
            <StudyPlayersTable
              style="min-width: 14rem"
              class="gw_table-box-layout_playersinfo"
              :asBlocks="true"
              :hasCombos="false"
              :players="[hero, opponent]"
              :bettingInfo
            />
          </div>

          <StudyPlayersTable
            v-if="tab === 'players'"
            style="max-height: 6rem; min-width: 0"
            :hasCombos="false"
            :players="[hero, opponent]"
            :bettingInfo
          />
        </div>
      </template>
    </TabBox>

    <TabBox
      v-if="!mobile"
      class="sprtsnasd_tabbox"
      style="--tbbox-overflow-y: unset; --tbbox-overflow-x: unset"
      :options="['singletab']"
      value="singletab"
      :hasNamedTabSlot="true"
    >
      <template #tab_singletab>
        <div
          @click="
            $store.dispatch('switchers_set_next', {
              key: 'sw_tabs_actions_reports',
            })
          "
        >
          {{ $t(`tabs.${actionreptab}`) }}
        </div>
        <GwMenu
          ref="gwmenu"
          @click.stop
        >
          <template #opener="{ value }">
            <div
              class="mdi text-semi-large transition_03 icon_btn mdi-menu-down gtabs_menu_icon"
              :class="{ rotated_180_before: value }"
              style="margin: 0 -0.5rem 0 0.25rem; transition: 0.22s"
              data-tst="options_rep_opener"
            />
          </template>
          <template #default="{ methods }">
            <GwBtns
              :value="actionreptab"
              :options="optionsRepActions"
              idKey="payload"
              class="gwbtns_vertical_primary gw_menu"
              @click="
                (_e, item) => {
                  $store.dispatch('switchers_set_item', {
                    key: 'sw_tabs_actions_reports',
                    item: { payload: item },
                  })
                  methods.toggleOpen(false)
                }
              "
            >
              <template #default="{ item }">
                {{ $t(`tabs.${item}`) }}
              </template>
            </GwBtns>
          </template>
        </GwMenu>
      </template>
      <template #default="{}">
        <div class="std_cont">
          <div
            class="f-column flex-1"
            style="min-height: 11rem; gap: 0.25rem"
            :class="{ 'no-events opacity_4': flopFilterDisabled }"
          >
            <StudyActionBtns
              :customSolution="solution"
              :isPreflop="isPreflop"
              :showFlopContent="showFlopContent"
              :useHex="useHex"
              :hasDisabledZeroFreqActions="hasDisabledZeroFreqActions"
              :showActions="actionreptab === 'actions'"
              :grouping="grouping"
              :showBetsIn="showBetsIn"
              freKey="frequency"
              :filterActions="filterCombos.actions"
              :hasBreakdown="false"
              :hasCombos="false"
              :applyFilterActionName="null"
            />
            <StudyGraphSolutions
              v-show="actionreptab === 'actions'"
              :customSolution="solution"
              freKey="frequency"
              :useHex="useHex"
              :hasLegend="false"
              style="--chart-height: 1.5em; --chart-radius: 4px"
            />
          </div>
        </div>
      </template>
    </TabBox>
    <TabBox
      class="sprtsnasd_tabbox flex-1"
      :swKey="mobile ? 'sw_tabs_reports_all' : 'sw_tabs_reports'"
      style="--tbbox-overflow-y: auto"
      :tabsStyle="mobile ? '--padding-inner:0 2.25rem 0 0;' : ''"
      :hasMinify="mobile"
      :scrollToActiveTab="mobile"
      :hasNamedTabSlot="true"
    >
      <template #tab_cards>
        {{
          viewProps.reportsStreetGroup
            ? $t(`common.${viewProps.reportsStreetGroup}_singular`)
            : $t('tabs.cards')
        }}
      </template>
      <template #default="{ tab }">
        <div
          class="sprtsnasd_content swp_cont"
          @touchstart="swpHandleTouchStart"
          @touchmove="swpHandleTouchMove"
          @touchend="
            e =>
              swpHandleTouchEnd(e, {
                treshold: 40,
                timeout: 500,
                swKey: mobile ? 'sw_tabs_reports_all' : 'sw_tabs_reports',
              })
          "
        >
          <ReportsFlopFilter
            v-if="hSpotStreet === 'flop' && tab === 'filters'"
            style="padding: 0.25rem"
            :style="mobile ? 'max-height:calc(var(--vh) * 33)' : ''"
            data-tst="reports_flop_filter_tab"
            :class="{ 'no-events opacity_4': flopFilterDisabled }"
          />
          <ReportsTurnFilter
            v-else-if="hSpotStreet === 'turn' && tab === 'filters'"
            style="padding: 0.25rem"
            :instaApply="true"
            :flopBoard
            :turnFilterHand
          />
          <div
            v-else
            class="std_cont"
          >
            <div
              v-if="tab === 'cards' && reportItem"
              data-tst="handtable_cells"
              class="f-column flex-1"
              style="min-height: 11rem"
            >
              <HandTableCell
                v-for="htcItem in htcItems"
                :key="htcItem.key"
                style="
                  --htc-title-height: 2rem;
                  --htc-title-size: 1.5rem;
                  --htc-blocker-icon-size: 1.625rem;
                  --htc-blocker-value-size: 1.5rem;
                "
                v-bind="htcItem.props"
                class="flex-1 rep_table_cell gw_hvr gw_hvr_pointer_coarse_disabled"
                :valueKeys="['eq', 'eqr', 'ev']"
                rangeKey="htc_range"
                :gameformat="gameformat"
                :comboPlayer="reportItem[htcItem.props.player]"
                :hasPremiumGameformat="hasPremiumGameformat"
                :combo="reportItem"
                :showBetsIn="showBetsIn"
                :showProp="
                  viewProps.colValue.key === 'strategy'
                    ? viewProps.colValue.showProp
                    : viewProps.colValue.key
                "
                :isPreflop="false"
                :grouping="grouping"
                :viewProps="viewProps"
                :useHex="useHex"
                :filterCombos="filterCombos"
                :asEmpty="false"
                :maximizible="false"
                :hasBlockers="false"
                :bettingInfo
              >
                <template #title>
                  <StudyReportsGroupItemTitle
                    v-if="reportItem.id"
                    :item="reportItem"
                    class="htc_title_symbols clr-black"
                    style="--font-size: 1.5rem"
                    :flopGroup="flopGroup"
                  />
                  <StudyReportsLinks
                    v-if="hasLinks && (flopGroup === 'swv_flops' || flopGroup === 'swv_turns')"
                    class="gw_hvr_content"
                    :namespace
                    :item="reportItem"
                    :flopGroup="flopGroup"
                    :flopBoard="flopBoard"
                    :linkParams="linkParams"
                    style="position: absolute; left: calc(100% + 0.5rem)"
                  />
                </template>
                <template #value>
                  <span
                    v-if="!viewProps.display_strategy"
                    class="uppercase"
                    style="position: absolute; left: 1rem"
                  >
                    {{ htcItem.player.position }}
                    <span style="font-size: 0.8em">
                      {{ htcItem.key }}
                    </span>
                    <i
                      v-if="htcItem.player.is_hero"
                      class="mdi mdi-crown position-relative"
                      style="top: 0.0875em"
                    />
                  </span>
                </template>
                <template #legend_before>
                  <UnSwitcherNew
                    swKey="sw_hand_content"
                    :hasText="true"
                    :asMenu="false"
                    style="
                      margin: 0 0 0.5rem auto;
                      --gwbtns-gap: 2px;
                      --gwbtn-padding: 0 0.5rem;
                      --gwbtn-clr-back: rgba(0, 0, 0, 0.25);
                      --gwbtn-clr-back: transparent;
                      --gwbtn-clr-active-white: rgba(0, 0, 0, 0.2);
                      --gwbtn-clr-hover-white: rgba(0, 0, 0, 0.2);
                      --gwbtn-clr: var(--clr-combo_text);
                      --gwbtn-clr-hover: var(--clr-combo_text);
                      --gwbtn-clr-active: var(--clr-combo_text);
                    "
                  />
                </template>
              </HandTableCell>
            </div>

            <!-- mobile -->
            <StudyPlayersTable
              v-if="tab === 'players'"
              :hasCombos="false"
              :players="[hero, opponent]"
              :bettingInfo
            />
            <div
              v-if="tab === 'actions' || tab === 'actions_chart'"
              class="f-column flex-1"
              style="min-height: 11rem; min-width: 0; gap: 0.25rem"
            >
              <StudyActionBtns
                style="overflow: auto"
                :customSolution="solution"
                :isPreflop="isPreflop"
                :useHex="useHex"
                :showActions="tab === 'actions'"
                :grouping="grouping"
                :showBetsIn="showBetsIn"
                freKey="frequency"
                :filterActions="filterCombos.actions"
                :hasBreakdown="false"
                :hasCombos="false"
                :applyFilterActionName="null"
              />
              <StudyGraphSolutions
                :customSolution="solution"
                freKey="frequency"
                :useHex="useHex"
                :hasLegend="false"
                style="--chart-height: 1.5em; --chart-radius: 4px"
              />
            </div>
          </div>
        </div>
      </template>
    </TabBox>
  </div>
</template>

<script>
import ReportsFlopFilter from '@/components/DataTables/Filters/ReportsFlopFilter'
import ReportsTurnFilter from '@/components/DataTables/Filters/ReportsTurnFilter'
import StudyReportsGroupItemTitle from '@/components/Study/StudyReportsGroupItemTitle'
import StudyReportsLinks from '@/components/Study/StudyReportsLinks'
import PokerTableStudy from '@/components/PokerTable/PokerTableStudy'
import TabBox from '@/components/lib/TabBox'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import GwMenu from '@/components/lib/GwMenu'
import GwBtns from '@/components/lib/GwBtns'
import { getSuitsSymbols, getSuitsConf } from '@/helpers/constants'
import { allSwitchers } from '@/store/switchers/switchers'

import StudyGraphSolutions from '@/components/Study/StudyGraphSolutions'
import StudyTableTile from '@/components/Study/StudyTableTile'
import StudyActionBtns from '@/components/Study/StudyActionBtns'
import HandTableCell from '@/components/Study/HandTableCell'
import StudyPlayersTable from '@/components/DataTables/v2/tables/StudyPlayersTable/StudyPlayersTable'

import links_mix from '@/mixins/links_mix'
import float_mix from '@/mixins/float_mix'
import swipe_mix from '@/mixins/swipe_mix'

export default {
  name: 'StudyReportsAside',
  components: {
    ReportsFlopFilter,
    ReportsTurnFilter,
    StudyReportsGroupItemTitle,
    StudyReportsLinks,
    HandTableCell,
    StudyGraphSolutions,
    StudyTableTile,
    StudyActionBtns,
    StudyPlayersTable,
    PokerTableStudy,
    TabBox,
    UnSwitcherNew,
    GwMenu,
    GwBtns,
  },
  mixins: [float_mix, links_mix, swipe_mix],
  props: {
    namespace: { required: true, type: String },
    hero: Object,
    opponent: Object,
    solution: { default: () => [] },
    isPreflop: Boolean,
    useHex: Boolean,
    grouping: String,
    filterCombos: Object,
    showBetsIn: String,
    bettingInfo: Object,
    reportItem: Object,
    hasPremiumGameformat: Boolean,
    gameformat: Object,
    viewProps: Object,
    hSpot: Object,
    street: String,
    hSpotStreet: String,
    mobile: Boolean,
    flopGroup: String,
    flopBoard: String,
    turnFilterHand: String,
    showFlopContent: Boolean,
    hasEmptyFlopBoard: Boolean,
    hasLinks: { default: true, type: Boolean },
    hasDisabledZeroFreqActions: Boolean,
    flopFilterDisabled: Boolean,
    linkParams: Object,
  },
  data() {
    this.suitsSymbols = getSuitsSymbols()
    this.suitsConf = getSuitsConf()

    const sww = allSwitchers()
    this.optionsRepActions = sww.sw_tabs_actions_reports.map(i => i.payload)

    return {}
  },
  methods: {
    swpLeft(eventData, { swKey }) {
      if (eventData.e.gw_touchends) {
        // console.log('swpLeft', eventData.e.gw_touchends)
        // scroll ro the end (right) wait a bit and then switch on second swipe
        if (
          !eventData.e.gw_touchends.some(
            i => i.ist_right && !i.ist_first && Date.now() - i.ist_right_time > 444,
          )
        )
          return
      }
      // console.log(eventData.e.gw_touchends)
      this.$store.dispatch('switchers_set_next', { key: swKey, num: 1 })
    },
    swpRight(eventData, { swKey }) {
      if (eventData.e.gw_touchends) {
        // console.log('swpRight', eventData.e.gw_touchends)
        // allow for move back instantly on first swipe right
        // if scrolled to right scrolled to left wait a bit and then switch on second swipe
        if (
          !eventData.e.gw_touchends.some(
            i => i.ist_left && (i.ist_first || Date.now() - i.ist_left_time > 444),
          )
        )
          return
      }
      this.$store.dispatch('switchers_set_next', { key: swKey, num: -1 })
    },
  },
  computed: {
    htcItems() {
      const vps = this.viewProps
      const res = [
        {
          visible: vps.display_strategy,
          key: 'strategy',
          props: {
            player: vps.heroRelPos,
            hasLegend: true,
          },
        },
        {
          visible: vps.display_oop,
          player: vps.oop_player,
          key: 'oop',
          props: {
            player: 'oop',
            hasLegend: false,
          },
        },
        {
          visible: vps.display_ip,
          player: vps.ip_player,
          key: 'ip',
          props: {
            player: 'ip',
            // is_hero: this.reportItem.ip?.is_hero,
            // position: this.reportItem.ip?.position,
            hasLegend: false,
          },
        },
      ].filter(htc => htc.visible)
      // console.log(res)
      return res
    },
    tabRange() {
      return this.tab === 'range'
    },
    actionreptab() {
      return this.$store.getters.sw_tabs_actions_reports
    },
  },
}
</script>
<style lang="scss" scoped>
.sprtsnasd {
  --gap: var(--laytsttd-gap, 0.5rem);
  gap: var(--gap);

  flex-direction: column;
  display: flex;
  flex: 1;

  min-height: 0;
  min-width: 0;

  &_tabbox {
    --tbbox-content-gap: var(--laytsttd-gap) !important;
    --tbbox-content-padding: var(--laytsttd-padding-content) !important;
  }

  &_content {
    display: flex;
    min-height: 100%;
    min-width: 100%;
  }

  --small-layout-aside-max-height: 33vh;
}
.rep_table_cell {
  outline: 1px solid var(--clr-black-0);
}

@media screen and (orientation: landscape) {
  .sprtsnasd {
    --small-layout-aside-max-height: auto;
  }
}
</style>
